module.exports = __webpack_public_path__ + "static/media/Discover.4142c7ab.svg";